/**
 * Method under which assignment was conducted
 * tag: 1049
 * @readonly
 * @enum {string} (char)
 */
export enum InstrmtAssignmentMethod {
  /** Pro rata */
  ProRata = 'P',
  /** Random */
  Random = 'R',
}
